(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-mobile-touch-event"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.currentY = 0;
      this.lastY = 0;
      this.sensivityThreshold = 10;
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      window.addEventListener('touchstart', (e) => {
        this.lastY = e.changedTouches[0].clientY;
      });

      window.addEventListener('touchmove', (e) => {
        const currentY = e.changedTouches[0].clientY;
        const diff = this.lastY - currentY;
        if (this.lastY > currentY && Math.abs(diff) <= this.sensivityThreshold) {
          this.header.classList.remove('is-scrolled-past-header');
          if (!this.preventHide) {
            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (this.lastY < currentY && Math.abs(diff) > this.sensivityThreshold) {
          this.header.classList.add('is-scrolled-past-header');
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);
            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);
            requestAnimationFrame(this.hide.bind(this));
          }
        }

        //this.lastY = currentY; // update for next move
      });

      window.addEventListener('touchend', (e) => {
        this.lastY = e.changedTouches[0].clientY;
      });

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    touchMove(e) {
      const currentY = e.touches[0].clientY;
      const diff = this.startY - currentY; 
      if(diff > this.threshold && !this.menuVisible) {

      }
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const headerBottom = this.header.offsetHeight;
      const SCROLL_THRESHOLD = 10; // adjust sensitivity

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      
      // 1. Reset at top
      if (scrollTop <= headerBottom) {
        this.header.classList.remove('is-scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      // 2. Scrolling down
      else if (scrollTop > this.currentScrollTop && scrollTop > headerBottom) {
        this.header.classList.remove('is-scrolled-past-header');
        if (!this.preventHide) {
          requestAnimationFrame(this.hide.bind(this));
        }
      }

      // 3. Scrolling up
      else if (scrollTop < this.currentScrollTop - SCROLL_THRESHOLD && scrollTop > headerBottom) {
        this.header.classList.add('is-scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }


    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  // Section JS is bundled theme-wide; leave sticky-header to the main header's scroll logic.
  if (!customElements.get('sticky-header') && !document.querySelector('sticky-header[data-scroll-header]')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  /*
   * Scroll header (mockup: .site-header.header-is-sticky.header-is-animated).
   * Above the header it stays in normal flow. Past it, the header hides while
   * scrolling down and slides back in while scrolling up, at every width.
   */
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.announcement = document.querySelector('.announcement-bar-section');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.headerStart = 0;
      this.headerBottom = 0;
      this.previousY = this.scrollY();
      this.direction = 0;
      this.travel = 0;
      this.scrollPending = false;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.measure();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('header-is-sticky', 'shopify-section-header-sticky');
      }

      this.onScrollHandler = this.onScroll.bind(this);
      this.onFocusIn = this.onFocusIn.bind(this);
      this.onPageShow = this.onPageShow.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      this.header.addEventListener('focusin', this.onFocusIn);
      window.addEventListener('pageshow', this.onPageShow);

      if (typeof ResizeObserver !== 'undefined') {
        this.resizeObserver = new ResizeObserver(() => this.resetScroll());
        this.resizeObserver.observe(this.header);
        if (this.announcement) this.resizeObserver.observe(this.announcement);
      }

    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      this.header.removeEventListener('focusin', this.onFocusIn);
      window.removeEventListener('pageshow', this.onPageShow);
      this.resizeObserver?.disconnect();
    }

    scrollY() {
      const y = window.scrollY || document.documentElement.scrollTop || 0;
      const maximum = document.documentElement.scrollHeight - window.innerHeight;
      return Math.max(0, Number.isFinite(maximum) ? Math.min(y, Math.max(0, maximum)) : y);
    }

    measure() {
      const rawY = window.scrollY || document.documentElement.scrollTop || 0;
      const height = this.header.offsetHeight;
      this.headerStart = this.announcement
        ? Math.max(0, this.announcement.getBoundingClientRect().bottom + rawY)
        : 0;
      this.headerBottom = this.headerStart + height;
      this.header.style.setProperty('--scroll-header-height', `${height}px`);
      document.documentElement.style.setProperty('--header-height', `${height}px`);
    }

    // Dialogs and drawers have their own scrolling; leave the header as it is. data-scroll-locked is set by
    // search-dialog.js while it pins the page and restores the scroll position.
    isLocked() {
      return (
        document.body.hasAttribute('data-scroll-locked') ||
        !!document.querySelector('dialog[open]') ||
        /(^|\s)overflow-hidden/.test(document.body.className) ||
        !!(this.predictiveSearch && this.predictiveSearch.isOpen)
      );
    }

    onScroll() {
      if (this.scrollPending) return;
      this.scrollPending = true;
      requestAnimationFrame(() => {
        this.scrollPending = false;
        this.update();
      });
    }

    update() {
      if (this.headerIsAlwaysSticky) return;

      const y = this.scrollY();
      const delta = y - this.previousY;
      this.previousY = y;

      // An open mega menu panel (click, keyboard or hover) keeps the header where it is (mega-menu.js).
      if (this.isLocked() || this.querySelector('mega-nav')?.isOpen?.()) {
        this.direction = 0;
        this.travel = 0;
        return;
      }

      if (y <= this.headerStart) {
        this.reset();
        this.direction = 0;
        this.travel = 0;
        return;
      }

      if (y <= this.headerBottom) {
        // On the first pass down it stays in normal flow. A header revealed on the
        // way back up stays visible until it rejoins that flow.
        if (this.isSticky()) this.reveal();
        this.direction = 0;
        this.travel = 0;
        return;
      }

      if (!this.isSticky()) {
        // Already off screen: enter the hidden sticky state without a jump.
        this.hide();
        this.direction = 0;
        this.travel = 0;
        return;
      }

      if (delta === 0) return;
      const direction = delta > 0 ? 1 : -1;
      this.travel = direction === this.direction ? this.travel + Math.abs(delta) : Math.abs(delta);
      this.direction = direction;
      if (this.travel < 6) return;

      if (direction < 0) {
        if (this.preventReveal) {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => (this.preventReveal = false), 66);
        } else {
          this.reveal();
        }
      } else if (!this.header.classList.contains('header-is-hidden')) {
        this.hide(true);
      }
      this.travel = 0;
    }

    resetScroll() {
      this.measure();
      if (this.headerIsAlwaysSticky) return;

      this.previousY = this.scrollY();
      this.direction = 0;
      this.travel = 0;
      if (this.previousY <= this.headerStart) this.reset();
      else if (this.previousY <= this.headerBottom) {
        if (this.isSticky()) this.reveal();
      } else if (!this.isSticky()) this.hide();
    }

    // Keyboard focus must always make the navigation available.
    onFocusIn() {
      this.resetScroll();
      if (!this.headerIsAlwaysSticky && this.scrollY() > this.headerStart) this.reveal();
    }

    onPageShow() {
      this.resetScroll();
      if (!this.headerIsAlwaysSticky && this.scrollY() > this.headerBottom) this.reveal();
    }

    isSticky() {
      return this.header.classList.contains('header-is-sticky');
    }

    hide(animate = false) {
      this.closeMenuDisclosure();
      this.querySelector('mega-nav')?.close?.();
      this.closeSearchModal();
      this.header.classList.toggle('header-is-animated', animate);
      this.header.classList.add('header-is-sticky', 'header-is-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('header-is-sticky', 'header-is-animated', 'shopify-section-header-sticky');
      this.header.classList.remove('header-is-hidden');
    }

    reset() {
      this.header.classList.remove(
        'header-is-sticky',
        'header-is-hidden',
        'header-is-animated',
        'shopify-section-header-sticky'
      );
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close?.());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close?.(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
